import { type TimezoneName, getCountry } from 'countries-and-timezones';
import dayjs from '../../dayjs.extend';

const getTimeZoneByCountryCode = (countryCode: string) => {
    const country = getCountry(countryCode);
    if (country?.timezones?.length) {
        const timezoneName = dayjs.tz.guess();

        return timezoneName && country.timezones.includes(timezoneName as TimezoneName)
            ? timezoneName
            : country.timezones[0];
    }

    return null;
};

export default getTimeZoneByCountryCode;
